import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const healthInsuranceSchema = Yup.object().shape({
    typeOfCoverage: Yup.string()
        .nullable()
        .required("Required"),
    companyName: Yup.string().when("typeOfCoverage", {
        is: val => val === "Insurance",
        then: Yup.string()
            .nullable()
            .required("Required"),
        otherwise: Yup.string().nullable(),
    }),
    memberNumber: Yup.string().when("typeOfCoverage", {
        is: val => val !== undefined,
        then: Yup.string().test("typeOfCoverage", "Required", function(value) {
            if (!value) {
                const isRequired = this.options.context
                    .filter(x => x.name === this.options.parent.typeOfCoverage)
                    .map(y => y.requiresMemberId === false)[0];

                console.log(isRequired);
                return isRequired;
            } else return true;
        }),
    }),
    /*companyNameOther: Yup.string().when("companyName", {
        is: "Other",
        then: Yup.string()
            .nullable()
            .required("required"),
        otherwise: Yup.string().nullable(),
    }),*/
    isSsiSSdCasePending: Yup.bool().when("typeOfCoverage", {
        is: "SSI/SSDI",
        then: Yup.bool()
            .nullable()
            .required("Required"),
        otherwise: Yup.bool().nullable(),
    }),
});

const thirdPartyValidationSchema = Yup.object().shape({
    typeOfAccident: Yup.string()
        .nullable()
        .required("Required"),
    policyNumber: Yup.string().when("typeOfAccident", {
        is: typeOfAccident =>
            typeOfAccident === "Automobile" ||
            typeOfAccident === "At someone's home" ||
            typeOfAccident === "At a place of business",
        then: Yup.string().nullable(),
        otherwise: Yup.string().nullable(),
    }),
    contactName: Yup.string().when("typeOfAccident", {
        is: typeOfAccident =>
            typeOfAccident === "Automobile" ||
            typeOfAccident === "At someone's home" ||
            typeOfAccident === "Work-Related" ||
            typeOfAccident === "At a place of business",
        then: Yup.string().nullable(),
        otherwise: Yup.string().nullable(),
    }),
    contactPhoneNumber: Yup.string().when("typeOfAccident", {
        is: typeOfAccident =>
            typeOfAccident === "Automobile" ||
            typeOfAccident === "Work-Related" ||
            typeOfAccident === "At a place of business",
        then: Yup.string()
            .nullable()
            .matches(phoneRegExp, "Invalid"),
        otherwise: Yup.string().nullable(),
    }),
    employerName: Yup.string().when("typeOfAccident", {
        is: typeOfAccident => typeOfAccident === "Work-Related",
        then: Yup.string().nullable(),
        otherwise: Yup.string().nullable(),
    }),
    workCompCarrier: Yup.string().when("typeOfAccident", {
        is: typeOfAccident => typeOfAccident === "Work-Related",
        then: Yup.string().nullable(),
        otherwise: Yup.string().nullable(),
    }),
    homeownerCompany: Yup.string().when("typeOfAccident", {
        is: typeOfAccident => typeOfAccident === "At someone's home",
        then: Yup.string().nullable(),
        otherwise: Yup.string().nullable(),
    }),
    phoneNumber: Yup.string().when("typeOfAccident", {
        is: typeOfAccident => typeOfAccident === "At someone's home",
        then: Yup.string()
            .nullable()
            .matches(phoneRegExp, "Invalid"),
        otherwise: Yup.string().nullable(),
    }),
    medPayCoverage: Yup.string().when("typeOfAccident", {
        is: typeOfAccident => typeOfAccident === "At someone's home",
        then: Yup.string().nullable(),
        otherwise: Yup.string().nullable(),
    }),
    liabilityLimits: Yup.string().when("typeOfAccident", {
        is: typeOfAccident => typeOfAccident === "At someone's home",
        then: Yup.string().nullable(),
        otherwise: Yup.string().nullable(),
    }),
    businessName: Yup.string().when("typeOfAccident", {
        is: typeOfAccident => typeOfAccident === "At a place of business",
        then: Yup.string().nullable(),
        otherwise: Yup.string().nullable(),
    }),
    hasChargesBeenFiledForViolentCrime: Yup.bool().when("typeOfAccident", {
        is: typeOfAccident => typeOfAccident === "Victim of violent crime",
        then: Yup.bool().nullable(),
        otherwise: Yup.bool().nullable(),
    }),
});

export const validationSchema = Yup.object().shape({
    hasCoverage: Yup.bool()
        .nullable()
        .required("Required"),
    primaryCoverage: Yup.object()
        .nullable()
        .when("hasCoverage", {
            is: true,
            then: healthInsuranceSchema,
            otherwise: Yup.object()
                .nullable()
                .shape({}),
        }),

    isSeekingMedicalServicesDueToAccidentOrCrime: Yup.bool()
        .nullable()
        .required("Required"),
    thirdPartyLiability: Yup.object().when("isSeekingMedicalServicesDueToAccidentOrCrime", {
        is: true,
        then: thirdPartyValidationSchema,
        otherwise: Yup.object()
            .nullable()
            .shape({}),
    }),
    provideManualCoverage: Yup.boolean().nullable(),
    coverageConfirmed: Yup.boolean()
        .nullable()
        .when("provideManualCoverage", {
            is: true,
            then: Yup.boolean().required("Required"),
        }),
});
